module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"action":{"toggle":"Přepnout navigaci"}},"de":{"action":{"toggle":"Navigation umschalten"}},"es":{"action":{"toggle":"Alternar la navegación"}},"fr":{"action":{"toggle":"Basculer la navigation"}}}')
  delete Component.options._Ctor
}
